import type { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiRadio: Components<CssVarsTheme>['MuiRadio'] = {
  defaultProps: {
    size: 'small'
  }
};
